<template>
  <section class="elementor-section elementor-top-section elementor-element elementor-element-cae2034 elementor-section-boxed elementor-section-height-default elementor-section-height-default">
    <div  class="elementor-container elementor-column-gap-no">
      <div class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-80dad97">
        <div class="elementor-widget-wrap elementor-element-populated">
          <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-befd3fe elementor-widget elementor-widget-text-editor">
            <div class="elementor-widget-container">
              <span class="about-title">{{ homeContentStore.contents.about.section }}</span>
            </div>
          </div>
          <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-e242adb elementor-widget elementor-widget-text-editor">
            <div class="elementor-widget-container">
              <p class="desc" v-html="homeContentStore.contents.about.descriptions"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-a5b3284">
        <div class="elementor-widget-wrap elementor-element-populated">
          <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-ddd5e93 elementor-widget elementor-widget-text-editor">
            <div class="elementor-widget-container">
              <span class="about-title">{{ homeContentStore.contents.vision.section }}</span>
            </div>
          </div>
          <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-e242adb elementor-widget elementor-widget-text-editor">
            <div class="elementor-widget-container">
              <p class="desc" v-html="homeContentStore.contents.vision.descriptions"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-215e70f">
        <div class="elementor-widget-wrap elementor-element-populated">
          <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-65345b4 elementor-widget elementor-widget-text-editor">
            <div class="elementor-widget-container">
              <span class="about-title">{{ homeContentStore.contents.mission.section }}</span>
            </div>
          </div>
          <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-e242adb elementor-widget elementor-widget-text-editor">
            <div class="elementor-widget-container">
              <p class="desc" v-html="homeContentStore.contents.mission.descriptions"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { onMounted } from 'vue'
  import { useHomeContentStore } from '@/stores/homeContentStore'

  export default {
    name: 'AboutUsSectionComponent',
    setup() {
      const homeContentStore = useHomeContentStore()

      onMounted(async () => {
        await homeContentStore.fetchContentPage()
      })

      return {
        homeContentStore
      }
    },
  }
</script>

<style scoped>
  .elementor-widget-container p.desc {
    /* color: #6F8C82; */
    color: #111111;
    font-size: 20px;
    font-weight: 200;
  }
  /* .elementor-1905 .elementor-element > .elementor-widget-wrap > .elementor-widget:not(.elementor-widget__width-auto):not(.elementor-widget__width-initial):not(:last-child):not(.elementor-absolute) {
    color: #006940;
  } */
  .elementor-widget-container span.about-title {
    color: #006940;
    font-weight: 500;
  }
</style>